import React from 'react';
import { View } from 'react-native-web';
import CheckBoxButton from '../Buttons/CheckBoxButton';

//= ========================================================================

const CheckBoxMenu = ({
  globJSON,
  onConfigChanged,
  transactions,
}) => (
  <View style={{
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 20,
    paddingHorizontal: 20,
    marginBottom: 30,
  }}
  >
    {globJSON.configurations.services.screens_ordering.filter((serviceKey) => globJSON.configurations.services[serviceKey].selected)
      .map((serviceKey) => {
        const service = globJSON.configurations.services[serviceKey];
        return (
          <CheckBoxButton
            title={service.name}
            isChecked={service.auth_within}
            onValueChanged={(value) => {
              service.auth_within = value;
              onConfigChanged();
            }}
            isDisabled={!transactions}
          />
        );
      })}
  </View>
);
export default CheckBoxMenu;
